import styled from "styled-components";

export const FooterMain = styled.section`
margin-left:16px;
margin-right:16px;

  .container {
    max-width: 966px;
    margin: 0 auto;
    border-left: 1px solid #3a3a3aff;
  }
  .flex {
    display: flex;
    flex-wrap: wrap;
  }
  @media (max-width: 480px) {
    .flex {
      flex-direction: column;
    }
  }
`;

interface FlexProps {
  align?: any;
}

export const FooterFlex = styled.div<FlexProps>`
  display: flex;
  align-items: ${(p) => p.align || "stretch"};
  justify-content: space-between;
  border-right: 1px solid #3a3a3aff;
  border-bottom: 1px solid #3a3a3aff;
  flex: 1 0 0;
  min-width: 200px;
  min-height: 200px;

  flex-direction: column;

  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const FooterAbout = styled.div`
  width: 100%;
  padding: 3rem 1.6rem;
  color: rgb(111, 111, 111);
  background-image: url("/images/footer.gif");
  background-size: 110%;
  background-position: 10%;
  flex: 1;

  width: 320px;
  height: 187px;

  > h3 {
    font-weight: 500;
    font-size: 30px;
  }
  .section {
    margin: 10px 0;
    width: fit-content;
  }

  .section-text {
    color: white;
    margin: 10px auto 0;
  }
  .img_div {
    width: 10rem;
    > img {
      width: 100%;
      height: 100%;
    }
  }

  p {
    font-weight: 400;
    font-size: 18px;
    margin: 0px;
    line-height: 1.2em;
    letter-spacing: 0.005em;
  }

  .footer-form {
    width: fit-content;
    position: relative;
    margin: 20px 0 10px;
  }
  .footer_input {
    background: rgb(13 13 13 / 80%);
    border-radius: 4px;
    padding: 4px;
    padding-right: 100px;
    border: none;
    outline: none;
    padding: 15px 170px 15px 15px;
    line-height: 1em;
    widtht: 100%;
    height: auto;
    border-box: box-sizing;

    font-size: 16px;
    color: white;
    box-shadow: inset 0 0 0 1px rgb(34, 34, 34);
  }
  .footer-form-button {
    padding: 0px 15px 0px 15px;
    border-radius: 3px;
    font-size: 16px;
    box-shadow: inset 0 0 0 1px rgb(34, 34, 34);
    background: rgb(13 13 13 / 80%);
    position: absolute;
    right: 6px;
    bottom: 6px;
    height: 38px;
    min-height: 40px;
  }

  @media (max-width: 900px) {
    width: 100%;
  }

  @media (max-width: 450px) {
    .footer_input {
      width: 100%;
    }
    .footer-form-button {
    }
  }
`;

export const FooterSocialWrap = styled.div`
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  height: 283px;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  position: relative;
  border-right: 1px solid #3a3a3aff;
  border-left: 1px solid #3a3a3aff;
  border-bottom: 1px solid #3a3a3aff;
  max-width: 966px;
  margin: 0 auto;

  &:after {
    content: "";
    border-width: var(--border-top-width, 0) var(--border-right-width, 0)
      var(--border-bottom-width, 0) var(--border-left-width, 0);
    border-color: var(--border-color, none);
    border-style: var(--border-style, none);
    width: 100%;
    height: 100%;
    position: absolute;
    box-sizing: border-box;
    left: 0;
    top: 0;
    border-radius: inherit;
    pointer-events: none;
  }

  > div {
    bottom: -28px;
    flex: none;
    left: 50%;
    position: absolute;
    white-space: pre;
    width: auto;
    z-index: 1;
    outline: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
    transform: translateX(-50%);
    > h2 {
      margin: 0px;
      font-size: 225px;
      color: rgb(23, 23, 23);
      > span {
        background-image: linear-gradient(
          0deg,
          rgb(23, 23, 23) 13%,
          rgba(23, 23, 23, 0) 100%
        );
        display: inline-block;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        padding: max(
          0em,
          calc(
            calc(
                1.3em -
                  var(
                    --framer-blockquote-line-height,
                    var(--framer-line-height, 1.3em)
                  )
              ) / 2
          )
        );
        margin: min(
          0em,
          calc(
            calc(
                1.3em -
                  var(
                    --framer-blockquote-line-height,
                    var(--framer-line-height, 1.3em)
                  )
              ) / -2
          )
        );
      }
    }
  }

  @media (max-width: 480px) {
    height: 180px;
    > div {
      h2 {
        font-size: 125px;
      }
    }
  }
    @media (min-width: 481px) and (max-width: 767px) {
        height: 200px;

     > div {

      h2 {
        font-size: 150px;
      }
    }
    
}
`;

export const FooterNavigations = styled.div`
  justify-content: space-between;
  p {
    font-weight: 400;
    font-size: 18px;
    margin: 0px;
    color: rgb(111, 111, 111);

    line-height: 1.2em;
    letter-spacing: 0.005em;
  }
  .h3 {
    font-size: 38px;
  }
  .footer-flex,
  .social-flex {
    display: flex;
  }
  .social-flex {
    flex-wrap: wrap;
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex: 1 0 0px;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 14px;
    height: auto;
    justify-content: flex-start;
    overflow: visible;
    position: relative;
  }
  .footer-flex {
    gap: 40px;
    margin: 10px 0;
    flex-wrap: wrap;
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex: 1 0 0px;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 14px;
    height: auto;
    justify-content: flex-start;
    overflow: visible;
    padding: 32px 24px;
    position: relative;
  }
  a {
    color: rgba(255, 255, 255, 0.65);
    transition: all 0.4s;
    cursor: pointer;
    text-decoration: none;
    text-transform: capitalize;
    font-size: 15px;
    &:hover {
      color: rgb(111, 111, 111);
    }
  }

  @media (max-width: 700px) {
  }
`;

export const CopyRightText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: color;
  flex: 1 0 0;
  width: 100%;
`;

export const RoundedSheet = styled.div`
  position: relative;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  height: 0.5rem;
  border-radius: 10px 10px 0 0;
  background: var(--main-bg);
`;
